module.exports = __webpack_public_path__ + "img/n5-5.15c43a38.png";